// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VideoCameraFilledSvg from "@ant-design/icons-svg/es/asn/VideoCameraFilled";
import AntdIcon from '../components/AntdIcon';

var VideoCameraFilled = function VideoCameraFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: VideoCameraFilledSvg
  }));
};

VideoCameraFilled.displayName = 'VideoCameraFilled';
export default React.forwardRef(VideoCameraFilled);